<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Fast Forward" class="d-icon d-icon--fast-forward" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g :clip-path="`url(#${uniqueID}a)`" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"><path d="M6.28 2.051a.5.5 0 0 1 .527.054l4.5 3.5a.5.5 0 0 1 0 .79l-4.5 3.5A.5.5 0 0 1 6 9.5v-7a.5.5 0 0 1 .28-.449ZM7 3.522v4.956L10.186 6 7 3.522Z"/><path d="M.78 2.051a.5.5 0 0 1 .527.054l4.5 3.5a.5.5 0 0 1 0 .79l-4.5 3.5A.5.5 0 0 1 .5 9.5v-7a.5.5 0 0 1 .28-.449Zm.72 1.471v4.956L4.686 6 1.5 3.522Z"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconFastForward',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
